var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIconFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_998_7105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.748 15.5811C19.8902 15.5811 23.248 12.2232 23.248 8.08105C23.248 3.93892 19.8902 0.581055 15.748 0.581055C11.6059 0.581055 8.24805 3.93892 8.24805 8.08105C8.24805 12.2232 11.6059 15.5811 15.748 15.5811Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.748 18.0801C9.5377 18.087 4.50496 23.1197 4.49805 29.3301C4.49805 30.0204 5.05768 30.5801 5.74803 30.5801H25.748C26.4384 30.5801 26.998 30.0204 26.998 29.3301C26.9911 23.1197 21.9584 18.0869 15.748 18.0801Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_998_7105"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.748047 0.581055)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIconFilled);
export default __webpack_public_path__ + "static/media/user-icon-filled.3228c551bda9e74003c29f4ce3e8030d.svg";
export { ForwardRef as ReactComponent };